import { render, staticRenderFns } from "./NotificationCardPathActivityPanel.vue?vue&type=template&id=3540dc2b&scoped=true&"
import script from "./NotificationCardPathActivityPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationCardPathActivityPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardPathActivityPanel.vue?vue&type=style&index=0&id=3540dc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540dc2b",
  null
  
)

export default component.exports